import React from 'react'

/**
 * The centered-column layout primitive: max 720px wide, horizontally
 * centered with 24px side padding. Use inside full-width pages to
 * constrain content below the page header (sidebar + header are not
 * affected). See design-language.md §6.10.
 */
export function PageContainer({ as: Tag = 'div', className = '', children, ...rest }) {
  const classes = ['page-container', className].filter(Boolean).join(' ')
  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  )
}
